import { useLazyQuery, useMutation } from '@apollo/client/react';
import { useEffect } from 'react';

import {
  GetDraftAppointmentUnreadOrganizationNotificationDocument,
  MarkOrganizationNotificationDocument,
} from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';

export const useMarkNotification = (draftAppointmentId: string | null) => {
  const [markNotification] = useMutation(MarkOrganizationNotificationDocument);
  const [getNotifications, { data }] = useLazyQuery(
    GetDraftAppointmentUnreadOrganizationNotificationDocument,
    {
      fetchPolicy: 'network-only',
    },
  );

  useEffect(() => {
    if (!data) return;
    const notifications = getNode(data, 'DraftAppointment')?.unreadOrganizationNotifications || [];

    for (const notification of notifications) {
      markNotification({
        variables: {
          input: {
            organizationNotificationId: notification.id,
          },
        },
      });
    }
  }, [data, markNotification]);

  useEffect(() => {
    if (draftAppointmentId) {
      getNotifications({
        variables: {
          draftAppointmentId,
        },
      });
    }
  }, [draftAppointmentId, getNotifications]);
};
